module.exports = __webpack_public_path__ + "img/mission-image-3.e9c6a58f.jpeg";